import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Sidebar from "../../components/common/Sidebar";
import Navbar from "../../components/common/Navbar";

import {
  getLeadByIdApi,
  updateLeadStatusApi,
  assignLeadApi
} from "../../services/leadsApi";

import "./LeadDetails.css";

const LeadDetails = () => {

  const { id } = useParams();
  const user = JSON.parse(localStorage.getItem("user"));

  const [lead, setLead] = useState(null);

  // =========================
  // FETCH LEAD
  // =========================
  const fetchLead = async () => {
    try {
      const res = await getLeadByIdApi(id);
      setLead(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchLead();
  }, [id]);

  // =========================
  // UPDATE STATUS
  // =========================
  const handleStatusChange = async (status) => {
    try {
      await updateLeadStatusApi(id, { status });

      setLead((prev) => ({ ...prev, status }));

    } catch (err) {
      alert("Error updating status");
    }
  };

  // =========================
  // ASSIGN LEAD
  // =========================
  const handleAssign = async () => {
    const userId = prompt("Enter Staff ID");

    if (!userId) return;

    try {
      await assignLeadApi(id, { assigned_to: userId });

      alert("✅ Assigned");

      fetchLead();

    } catch (err) {
      alert("Error assigning");
    }
  };

  if (!lead) return <p>Loading...</p>;

  return (
    <div className="admin-container">

      <Sidebar role={user?.role} />

      <div className="admin-main">

        <Navbar />

        <div className="admin-content">

          <h2>📌 Lead Details</h2>

          {/* ===== BASIC INFO ===== */}
          <div className="lead-card">

            <h3>{lead.shop_name}</h3>

            <p><b>Owner:</b> {lead.owner_name}</p>
            <p><b>Phone:</b> {lead.phone}</p>
            <p><b>Alt Phone:</b> {lead.alternate_phone}</p>
            <p><b>Address:</b> {lead.address}</p>
            <p><b>City:</b> {lead.city}</p>
            <p><b>State:</b> {lead.state}</p>

            <p><b>Created At:</b> {new Date(lead.created_at).toLocaleString()}</p>

          </div>

          {/* ===== STATUS ===== */}
          <div className="lead-card">

            <h3>Status</h3>

            <select
              value={lead.status}
              onChange={(e) => handleStatusChange(e.target.value)}
            >
              <option value="NEW">NEW</option>
              <option value="CONTACTED">CONTACTED</option>
              <option value="FOLLOWUP">FOLLOWUP</option>
              <option value="CLOSED">CLOSED</option>
            </select>

          </div>

          {/* ===== ASSIGN (ADMIN ONLY) ===== */}
          {user?.role === "admin" && (
            <div className="lead-card">

              <h3>Assign Lead</h3>

              <button onClick={handleAssign}>
                Assign to Staff
              </button>

            </div>
          )}

          {/* 🔥 NEXT: TIMELINE WILL COME HERE */}
          <div className="lead-card">
            <h3>Timeline (Coming Next)</h3>
          </div>

        </div>
      </div>
    </div>
  );
};

export default LeadDetails;